// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pad-left-1 {
  padding-left: 1em;
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/shared/post-viewers/post-comments/post-comments.component.scss"],"names":[],"mappings":"AAKA;EACE,iBAAA;AAJF","sourcesContent":["// * {\n//   font-size: 14px;\n//   color: var(--undp-jtf-btn-dark-color);\n// }\n\n.pad-left-1 {\n  padding-left: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
